module.exports = __webpack_public_path__ + "img/banner.62122540.svg";